import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { HotToastService } from "@ngneat/hot-toast";
import { DashboardStore } from "../../dashboard.store";

import { FilePreviewService } from "./file-preview.service";
import { MoveFileModalComponent } from "../accountant/modals/move-file-modal.component";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { FilesManagerService } from "../../files-manager/files-manager.service";
import { EmailService } from "../../email/email.service";
import { DomSanitizer } from "@angular/platform-browser";
import {
  PDFDocumentProxy,
  PDFProgressData,
  PdfViewerModule,
} from "ng2-pdf-viewer";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { FormsModule } from "@angular/forms";
import { NgxDocViewerModule } from "ngx-doc-viewer";
import { NgIf } from "@angular/common";

@Component({
  selector: "ch-file-preview",
  templateUrl: "./new-file-preview.component.html",
  styleUrls: ["./file-preview.component.scss"],
  imports: [
    NgIf,
    NgxDocViewerModule,
    PdfViewerModule,
    FormsModule,
    TooltipModule,
  ],
})
export class NewFilePreviewComponent implements OnInit {
  file: any = {
    type: "",
    url: "",
    etag: "",
    file: "",
    resourceId: "",
    prevent: false,
  };

  isQboItemPreview = false;

  data: any;

  isAccountant: boolean = false;

  disabledButtons = [];

  renamingFile = false;

  isLoaded = false;
  totalPages: number;
  page: number = 1;
  zoom: number = 1;

  bsModalRef: BsModalRef;
  folderName: string = null;

  constructor(
    private filePreviewService: FilePreviewService,
    private filesManagerService: FilesManagerService,
    public toastr: HotToastService,
    private modalService: BsModalService,
    private dashboardStore: DashboardStore,
    private localStorage: LocalStorageService,
    private cdr: ChangeDetectorRef,
    private emailService: EmailService,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    this.data = this.localStorage.get("data");
    this.isAccountant = this.data["user_type"] == 1;

    this.filePreviewService.openFile.subscribe((f: any) => {
      this.isQboItemPreview = f.isQboItemPreviw ?? false;
      this.page = 1;
      this.zoom = 1;
      this.totalPages = 1;
      this.file = f.file;

      this.disabledButtons = f.disabledButtons ?? [];

      this.refreshUrl();
      if (this.file.folder) {
        this.filesManagerService
          .getFolderNameByUuid(this.file.folder_uuid)
          .then(({ folder_name }) => (this.folderName = folder_name));
      }

      if (this.file["from_attachment"]) {
        console.log("from attachment", this.file);
        if (
          ["pdf", "doc", "docx", "xls", "xlsx"].includes(
            this.file.ext.toLowerCase(),
          )
        ) {
          this.file.file = this.file.secure_url;
        } else {
          this.file.file = this.sanitizer.bypassSecurityTrustResourceUrl(
            this.file.secure_url,
          );
        }
      }

      this.cdr.detectChanges();
    });
  }

  refreshUrl(): void {
    if (!this.file.url.includes("blob:") && !this.file["from_attachment"]) {
      this.filesManagerService
        .getFileDetailsByUuid(
          this.file.etag !== undefined ? this.file.etag : this.file.etag,
        )
        .subscribe((result) => {
          this.file = result.file;

          this.isLoaded = true;
        });
    }
  }

  afterLoadComplete(pdfData: PDFDocumentProxy) {
    this.totalPages = pdfData.numPages;
    this.isLoaded = true;
  }

  onProgress(progressData: PDFProgressData) {
    // do anything with progress data. For example progress indicator
  }

  nextPage() {
    this.page++;
  }

  prevPage() {
    this.page--;
  }

  zoomIn() {
    this.zoom = Number((this.zoom + 0.1).toFixed(1));
  }

  zoomOut() {
    this.zoom = Number((this.zoom - 0.1).toFixed(1));
  }

  onError(event: any) {
    console.log(event);
  }

  downloadFile(): void {
    if (this.file["from_attachment"]) {
      this.emailService
        .getAttachmentContent(this.file["inbox"], this.file["attachment"]["id"])
        .subscribe(
          (res: any) => {
            const blob = res.slice(
              0,
              res.size,
              this.file["attachment"]["contentType"],
            );
            const _url = window.URL.createObjectURL(blob);

            var link = document.createElement("a");
            link.href = _url;
            link.download = this.file["attachment"]["filename"];

            link.dispatchEvent(
              new MouseEvent("click", {
                bubbles: true,
                cancelable: true,
                view: window,
              }),
            );
          },
          (err) => {},
        );

      return;
    }

    this.filesManagerService.download(
      this.file.etag !== undefined ? this.file.etag : this.file.etag,
    );
  }

  printFile(): void {}

  closeFilePreview() {
    this.renamingFile = false;
    this.disabledButtons = [];
    this.filePreviewService.closeFile.next(null);
  }

  openModalDeleteFile(template) {
    this.bsModalRef = this.modalService.show(template);
  }

  openRenameFile() {
    this.renamingFile = true;
  }

  async openModalMoveFile() {
    // if file is from attachment, make sure availableWorkspaces is > 0, else show a
    // toast asking them to link the thread to at least one workspace
    if (
      this.file["from_attachment"] &&
      this.file["availableWorkspaces"].length == 0
    ) {
      this.toastr.error(
        "Please link the email thread to at least one workspace before moving the file.",
      );
      return;
    }

    const initialState = {
      currentConversationID:
        this.dashboardStore.currentCompany != null
          ? this.dashboardStore.currentCompany["company_conversation"].id
          : null,
      fileDetails: {
        filename: this.file.filename,
        etag: this.file.etag,
      },
      showWorkspaceSelector: this.file["from_attachment"] ? true : false,
      availableWorkspaces: this.file["availableWorkspaces"],
    };

    const moveFileModal = this.modalService.show(MoveFileModalComponent, {
      initialState,
    });
    moveFileModal.content.onClose.subscribe(
      async ({ target_uuid, selectedWorkspace }) => {
        // target_uuid can be false if the modal was just closed
        if (!target_uuid) {
          moveFileModal.hide();
          return;
        }
        const payload: any = {
          folder: target_uuid,
          file: this.file.etag,
        };

        let companyConversationId = null;

        if (this.file["from_attachment"]) {
          // Create a file for the attachment
          let createdFile = await this.emailService.createAttachmentFile(
            this.file.inbox,
            this.file.attachment.id,
            selectedWorkspace.uuid,
            this.file.emailMessage.uuid,
            this.file.attachment,
          );

          payload["file"] = createdFile["file"]["etag"];

          console.log({ payload });

          companyConversationId = selectedWorkspace.company_conversation.id;
        } else {
          companyConversationId =
            this.dashboardStore.currentCompany["company_conversation"].id;
        }

        this.filesManagerService.moveFile(companyConversationId, payload).then(
          (result) => {
            moveFileModal.hide();
            this.toastr.success(`File successfully moved`);

            this.filesManagerService.fileChanged.next({
              action: "move",
              target_uuid,
              file: this.file,
            });

            moveFileModal.hide();
            this.closeFilePreview();
          },
          (error) => {
            moveFileModal.hide();
            this.toastr.error("Something went wrong when moving the file.");
          },
        );
      },
    );
  }

  renameFile(uuid, name) {
    // this.is_loading = true;
    this.filesManagerService
      .renameFile(
        this.dashboardStore.currentCompany["company_conversation"].id,
        uuid,
        name,
      )
      .then(
        (result) => {
          // this.is_loading = false;

          this.renamingFile = false;
          this.toastr.success("File renamed successfully.");
          this.file.name = name;
          this.filesManagerService.fileChanged.next({
            action: "rename",
            file: this.file,
          });
          this.closeFilePreview();
          this.cdr.detectChanges();
        },
        (error) => {
          // this.is_loading = false;
          this.renamingFile = false;
          this.toastr.error("Something went wrong when renaming the file.");
        },
      );
  }

  deleteFile(uuid: string) {
    // this.is_loading = true;
    this.filesManagerService
      .deleteFile(
        this.dashboardStore.currentCompany["company_conversation"].id,
        uuid,
      )
      .then(
        (result) => {
          // this.is_loading = false;

          this.toastr.success("File deleted successfully.");
          this.filesManagerService.fileChanged.next({
            action: "delete",
            file: this.file,
          });
          this.bsModalRef.hide();
          this.closeFilePreview();
        },
        (error) => {
          this.toastr.error("Something went wrong when deleting the file.");
          this.bsModalRef.hide();
        },
      );
  }

  shouldDisableButton(button: string): boolean {
    return this.disabledButtons.indexOf(button) > -1;
  }

  checkClientForDeleteFile(): boolean {
    const now = new Date();
    const twentyFourHoursAgo = new Date(now.getTime() - 24 * 60 * 60 * 1000);
    const file = this.file;
    if (
      file.sent_by?.id == this.data.user?.id &&
      new Date(file.upload_date) >= twentyFourHoursAgo
    ) {
      return true;
    }
    return false;
  }
}
